import "./PricingDetail.css";

const PricingDetail = ({
	selectedPlan,
	yearlyBilling,
	detailPrice,
	savings,
	showSavings,
	primaryLabel,
	isProcessing,
	isLoggedIn,
	paidPlansEnabled,
	onSubscribe,
	onLogin,
}) => {
	return (
		<div
			className="pricing-detail"
			style={{ "--plan-color": selectedPlan.color }}
		>
			<div className="pricing-detail-info">
				<span className="pricing-detail-label">
					{selectedPlan.disabled ? "Coming Soon" : "You selected"}
				</span>
				<h2 className="pricing-detail-name">{selectedPlan.title} Plan</h2>
				<p className="pricing-detail-tagline">{selectedPlan.tagline}</p>
				<ul className="pricing-detail-highlights">
					<li className="pricing-detail-highlight">
						<span className="pricing-detail-highlight-dot" />
						{selectedPlan.devices} simultaneous device
						{selectedPlan.devices > 1 ? "s" : ""}
					</li>
					<li className="pricing-detail-highlight">
						<span className="pricing-detail-highlight-dot" />
						{selectedPlan.streamingHours
							? `${selectedPlan.streamingHours} hrs / month`
							: "Unlimited streaming"}
					</li>
					<li className="pricing-detail-highlight">
						<span className="pricing-detail-highlight-dot" />
						{selectedPlan.collectionLabel} collections
					</li>
					<li className="pricing-detail-highlight">
						<span className="pricing-detail-highlight-dot" />
						{selectedPlan.playlist
							? "Playlist playback"
							: "No playlist playback"}
					</li>
					<li className="pricing-detail-highlight">
						<span className="pricing-detail-highlight-dot" />
						{selectedPlan.commercial
							? "Commercial use allowed"
							: "Personal use only"}
					</li>
				</ul>
			</div>

			<div className="pricing-detail-cta">
				{!selectedPlan.disabled && (
					<>
						<div className="pricing-detail-price">
							${detailPrice.toFixed(2)}
							<span className="pricing-detail-price-period">
								/{yearlyBilling ? "year" : "month"}
							</span>
						</div>
						<div className="pricing-detail-billed">
							{yearlyBilling
								? "Billed annually"
								: "Billed monthly, cancel anytime"}
						</div>
						{showSavings && (
							<div className="pricing-detail-save">
								You save ${savings.toFixed(2)} per year
							</div>
						)}
					</>
				)}

				<div className="pricing-detail-buttons">
					<button
						type="button"
						className="pricing-btn is-primary"
						onClick={onSubscribe}
						disabled={isProcessing || selectedPlan.disabled}
					>
						{isProcessing ? (
							<span className="pricing-btn-spinner" />
						) : (
							primaryLabel
						)}
					</button>
					{!isLoggedIn &&
						paidPlansEnabled &&
						selectedPlan.key !== "free" &&
						!selectedPlan.disabled && (
							<button type="button" className="pricing-btn" onClick={onLogin}>
								I already have an account
							</button>
						)}
				</div>
			</div>
		</div>
	);
};

export default PricingDetail;
